import { render, staticRenderFns } from "./MaterialChip.vue?vue&type=template&id=073879f8&scoped=true"
import script from "./MaterialChip.vue?vue&type=script&lang=js"
export * from "./MaterialChip.vue?vue&type=script&lang=js"
import style0 from "./MaterialChip.vue?vue&type=style&index=0&id=073879f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073879f8",
  null
  
)

export default component.exports